import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "small-6 small-offset-3 small-centered";
},"3":function(container,depth0,helpers,partials,data) {
    return "small-12";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <p class=\"get-app-text\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":15,"column":10},"end":{"line":15,"column":23}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section\n  id=\"sticky-navbar-module\"\n  class=\"sticky spa-sticky "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1), depth0))
    + "\"\n  data-sticky-level=\"2\"\n  data-sticky-start=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"sticky-start-id") : stack1), depth0))
    + "\"\n  data-sticky-full-width=\"true\"\n  data-sticky-fade=\"true\">\n  <div class=\"row\">\n    <div class=\"column "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"small-centered") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":9,"column":23},"end":{"line":9,"column":112}}})) != null ? stack1 : "")
    + " medium-12 medium-uncentered\">\n      <div class=\"sticky-content\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":8},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"small") : stack1),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":16,"column":17}}})) != null ? stack1 : "")
    + "      </div>\n    </div>\n  </div>\n</section>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/sticky-navbar-module",
  "version": "2.0.0",
  "id": "stickyNavbarModule",
  "containerID": "creditCardsStickyNavbarModule",
  "moduleName": "credit-cards-sticky-navbar-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "sticky-navbar-module",
  "data": {
    "init": "stickyNavbarModuleJS"
  },
  "moduleParams": [{
    "name": "skin",
    "type": "string",
    "default": "",
    "description": "Allows a skin to be applied to the navbar"
  }, {
    "name": "small-centered",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Centers content on small screens"
  }, {
    "name": "sticky-start-id",
    "type": "string",
    "default": "",
    "description": "Attaches sticky starting from this id"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link
  },
  "dependencies": {
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
 * sticky-navbar-module
 * module_js_id: stickyNavbarModuleJS
 *
 * Copyright (c) 2016-11-21 removed
 */

/**
 * @class stickyNavbarModuleJS
 * @extends Module
 */
class stickyNavbarModuleJS extends Module {
  /**
   * Creates an instance of stickyNavbarModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof stickyNavbarModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Initializer
   * @returns {undefined}
   */
  init() {
    const btn = this.settings.target.querySelector('.get-app-btn');
    if (btn) {
      btn.addEventListener('click', this.openGetAppModal.bind(this));
    }
  }

  /**
   * Opens get app modal
   * @param {Event} e event
   * @returns {undefined}
   */
  openGetAppModal(e) {
    // prevent
    e.preventDefault();
    // trigger get app modal
    spartaEventsUtility.pub('OPEN.globalGetAppModal', e);
  }
}
registerModuleClass({
  moduleClass: stickyNavbarModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { stickyNavbarModuleJS as default, moduleConfig };
